import { Action } from "@/interface/action";

let initialState = {
  defaultSelectedKeys: [] as string[],
  defaultOpenKeys: [] as string[],
  selectedKeys: [] as string[],
  keyPath: [] as string[],
}

export const Menu = (state = initialState, action: Action) => {
  switch (action.type) {
    case "SET_MENU_SELECTED_KEYS":
      return {
        ...state,
        selectedKeys: [...action.payload.selectedKeys],
        keyPath: [...action.payload.keyPath]
      };
    case 'PUSH_MENU_KEYPATH': // 主要用在页面上的跳转路由时设置路径导航参数，和菜单区分使用
      return {
        ...state,
        keyPath: [...state.keyPath, action.payload.keyPath],
        selectedKeys: [...state.selectedKeys, action.payload.selectedKeys]
      };
    case 'POP_MENU_KEYPATH': // 主要用在页面上的跳转路由时设置路径导航参数，和菜单区分使用
      return {
        ...state,
        keyPath: [...state.keyPath.slice(0, action.payload.keyPath + 1)],
        selectedKeys: [...state.selectedKeys.slice(0, action.payload.selectedKeys + 1)],
      };
    case "SET_MENU_DEFAULT_SELECTED_KEYS":
      return {...state, defaultSelectedKeys: action.payload };
    case "SET_MENU_DEFAULT_OPEN_KEYS":
      return {...state, defaultOpenKeys: action.payload };
    case "CLEAR_MENU":
    case "RESET":
      return initialState;
    default:
      // 默认情况下，返回当前状态，不做任何改变
      return state;
  }
}